const Content = {
  margin: '50px 40px 30px 40px',
  font: 'normal normal normal 16px/20px ProximaNova'
};

export const FormsViewstyles = {
  Content
};
